module.exports = __webpack_public_path__ + "static/media/nav-chat-white.429d0431.svg";